import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const transferComplaint = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/Transfer",
    params
  );
};

export {
    transferComplaint
}